import React, { useEffect, useState } from "react";
import { TextField } from "../../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import styles from "../GroupConfiguration/GroupConfiguration.style";

export interface GroupNameProps {
	groupNameValue: string;
	onGroupNameChange: (name: string) => void;
	isReadOnly: boolean;
	highlightRequiredDetail: boolean;
}

export const GroupName: React.FC<GroupNameProps> = ({
	groupNameValue,
	onGroupNameChange,
	isReadOnly,
	highlightRequiredDetail,
}) => {
	const strings = useGetComponentStringsContext().GroupName;
	const classes = styles();
	const [isInputTouched, setIsInputTouched] = useState<boolean>(false);

	useEffect(() => {
		if (highlightRequiredDetail) {
			setIsInputTouched(true);
		}
	}, [highlightRequiredDetail]);

	function isError(): boolean {
		return !groupNameValue && highlightRequiredDetail
			? true
			: !groupNameValue && isInputTouched;
	}

	const onGroupNameUpdate = (event: any) => {
		setIsInputTouched(true);
		onGroupNameChange(event.target.value);
	};

	return (
		<TextField
			required
			data-testid="groupName"
			label={strings.groupNameLabel}
			value={groupNameValue}
			onChange={(event: any) => onGroupNameUpdate(event)}
			className={classes.groupNameTitle}
			InputProps={{ readOnly: isReadOnly }}
			disabled={isReadOnly}
			error={isError()}
		/>
	);
};
